import React from 'react';

import { Label, Spinner } from '@ergeon/core-components';

const LoadingState = () => (
  <div className="flex flex-col justify-center items-center gap-2 p-4 h-full">
    <Spinner active borderWidth={0.15} color="lightgray" size={32} />
    <Label>Loading...</Label>
  </div>
);

export default LoadingState;
